export default __webpack_public_path__ + "static/media/settings.b3f5a6ec.svg";